"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contextTypes = undefined;

var _propTypes = require("prop-types");

var contextTypes = exports.contextTypes = {
  freactal: _propTypes.object
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/freactal/lib/context.js
// module id = 330
// module chunks = 0